import Reveal from "@/components/Reveal";

export default function SectionHead({ label, title, lead, arm, align = "left", dark = false, className = "" }) {
  return (
    <Reveal className={className}>
      <div data-arm={arm} className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
        {label && (
          <p className={`hp-label ${arm ? "hp-arm-accent" : dark ? "text-sky-300" : "text-[var(--hop-brand)]"} ${align === "center" ? "justify-center" : ""}`}>
            {label}
          </p>
        )}
        <h2 className="hp-h2 mt-3">{title}</h2>
        {lead && <p className={`hp-lead mt-5 ${align === "center" ? "mx-auto" : ""}`}>{lead}</p>}
      </div>
    </Reveal>
  );
}
